export const COMPONENT_NAME = 'FlexiVisual';